import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'
import { genUniId } from '@/util/commonFuncs'
import { buryPointApi } from '@/util/commonFuncs.js'
import { webId } from '@/util/configure'
import {
  regReplaceArcRadius,
  regReplaceAxisOffset,
  regReplaceCuttingDockInputCheck,
  regReplaceCuttingParamsDiameter,
} from '@/util/regReplace'
import { message } from 'ant-design-vue'
import {
  computed,
  getCurrentInstance,
  nextTick,
  ref,
  watch,
} from 'vue'

import { backKnifeStoreConfigList } from './config/tableConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'laserCuttingMachine',
  props: {
  obj: {
    type: [Array, Object],
    default: () => {},
  },
  knifeTypeOptions: {
    type: [Array, Object],
    default: () => [],
  },
},
  emits: ['changeLaserEnable'],
  setup(__props, { expose, emit }) {

const props = __props

const that = getCurrentInstance()?.proxy as any
const formData = ref<{ [key: string]: any }>({
  laser_enable: false,
  back_knives: [] as any[],
  laser_tool_settings: {
    laser_open_code: '',
    laser_close_code: '',
  },
  cut_setting: {
    back_safe_hight: 0,
    knife_distance_to_plank: 0,
  },
  coordinate_axis: {
    X: 'U',
    Y: 'V',
    Z: 'W',
  },
})


const handleChangeLaserEnable = (val: boolean) => {
  buryPointApi('engraving', 'laser_setting_laser_enable')
  emit('changeLaserEnable', val)
}
const knifeTypeOptionsList = computed(() => {
  // 如果有一把激光刀，则激光刀不可选
  let laserKnife = formData.value.back_knives.find(
    (item: any) => item.type === 'laser'
  )
  let knifeTypeOptions = JSON.parse(JSON.stringify(props.knifeTypeOptions))
  knifeTypeOptions.forEach((item: any) => {
    if (laserKnife) {
      if (item.value === 'laser') {
        item.isDisabled = true
      } else {
        item.isDisabled = false
      }
    } else {
      item.isDisabled = false
    }
  })
  return knifeTypeOptions
})
watch(
  () => props.obj,
  (newVal) => {
    if (newVal) {
      if (Object.keys(newVal).length > 0) {
        let s = JSON.parse(JSON.stringify(newVal))
        let knives: any[] = []
        Object.keys(s.back_knives).forEach((v) => {
          knives.push(s.back_knives[v])
        })
        s.back_knives = knives
        let ss = ['millableHole', 'millableSlot', 'slotable', 'holeable']
        s.back_knives.forEach((v) => {
          v.knifePurpose = []
          ss.forEach((x) => {
            if (v[x] == true) {
              v.knifePurpose.push(x)
            }
          })
          // 确保每个刀具都有 webId，如果没有则生成一个
          if (!v[webId]) {
            v[webId] = genUniId()
          }
        })
        formData.value = s
      }
    }
  },
  { deep: true, immediate: true }
)
const coordinateAxes = [
  {
    key: 'x',
    label: 'cuttingDock.laserCuttingMachine.xAxis',
    modelKey: 'X',
    inputId: 'laser_cutting_machine_coordinate_x_input',
  },
  {
    key: 'y',
    label: 'cuttingDock.laserCuttingMachine.yAxis',
    modelKey: 'Y',
    inputId: 'laser_cutting_machine_coordinate_y_input',
  },
  {
    key: 'z',
    label: 'cuttingDock.laserCuttingMachine.zAxis',
    modelKey: 'Z',
    inputId: 'laser_cutting_machine_coordinate_z_input',
  },
]

const handleAddNewKnife = () => {
  formData.value.back_knives.push({
    desc: '',
    name: '',
    diameter: '',
    type: 'mill',
    cutable: false,
    use: '',
    moveZF: '',
    cutZF: '',
    moveF: '',
    cutF: '',
    startCode: '',
    stopCode: '',
    webId: genUniId(),
  } as any)
}

const handleDeleteKnife = () => {
  // if (formData.value.back_knives.length > 0) {
  //   formData.value.back_knives.pop()
  // }
  if (formData.value.back_knives.length < 2) {
    message.error(that.$translateLang('刀具不能少于1个'))
    return
  }
  if (currentRow.value.cutable) {
    message.error(that.$translateLang('不能删除开料刀'))
    return
  }
  formData.value.back_knives.splice(
    formData.value.back_knives.findIndex(
      (v: any) => v.index == currentRow.value.index
    ),
    1
  )
}
// 记录当前选中的行
const currentRow = ref<any>({})
// 记录行索引
const rowIndex = ref(-1)
// 记录列索引
const columnIndex = ref(-1)
// 记录输入框引用
const editInputRef = ref(null)
// 生成表格的 key，基于列配置，避免不必要的重新渲染
const tableKey = () => {
  // const hasObliqueDrill = formData.value.back_knives.some(
  //   (item) => item.type && item.type.includes('obliqueDrill')
  // )
  // const hasInnerShapeToolMatch =
  //   store.state.preferencesSetting.setting.inner_shape_tool_match
  // -${this.showConfig}-${this.showCode2}
  return `-`
}
// 更改行样式
const changeStyle = ({ row, rowIndex }: { row: any; rowIndex: number }) => {
  if (currentRow.value?.index == rowIndex) {
    return {
      height: '54px',
      'border-top': '1px solid #EEEEEE',
      'font-size': '14px',
      color: '#000000',
      'font-weight': '400',
      background: 'rgba(24, 168, 199, 0.2)',
    }
  }
  return {
    height: '54px',
    'border-top': '1px solid #EEEEEE',
    'font-size': '14px',
    color: '#000000',
    'font-weight': '400',
  }
}
// 更改单元格样式
const columnStyle = ({
  row,
  column,
  rowIndex,
  columnIndex,
}: {
  row: any
  column: any
  rowIndex: number
  columnIndex: number
}) => {
  if (column.property === 'id') {
    return 'padding-left: 16px'
  }
}
// 更改表头单元格样式
const headerStyle = ({
  row,
  column,
  rowIndex,
  columnIndex,
}: {
  row: any
  column: any
  rowIndex: number
  columnIndex: number
}) => {
  if (column.property === 'id') {
    return 'padding-left: 16px; box-sizing: border-box;background: #fafafa'
  }
  return 'background: #fafafa'
}
// 更改表头行样式
const headerRowStyle = ({ row, rowIndex }: { row: any; rowIndex: number }) => {
  return {
    height: '54px',
    'font-size': '14px',
    color: '#000000',
    'font-weight': '500',
    'border-bottom': 'none',
  }
}
// 选中刀具
const choseKnife = (row: any, column: any, event: any) => {
  currentRow.value = row
}
//把每一行的索引加到行数据中
const tableRowClassName = ({
  row,
  rowIndex,
}: {
  row: any
  rowIndex: number
}) => {
  row.index = rowIndex
}
//把每一列的索引加到列数据中
const tableCellClassName = ({
  column,
  columnIndex,
}: {
  column: any
  columnIndex: number
}) => {
  column.index = columnIndex
}
// 点击单元格切换成输入框
const cellClick = (row: any, column: any, cell: any, event: any) => {
  if (column.property == 'id' || column.property == 'desc') {
    return
  }
  rowIndex.value = row.index
  columnIndex.value = column.index
  if (
    column.property != 'use' &&
    column.property != 'type' &&
    column.property != 'cutable'
  ) {
    nextTick(() => {
      editInputRef.value && editInputRef.value[0]?.focus()
    })
  }
}
// 输入框的限制
const validatePositiveDecimal = (e: any, key: string, deepKey: string) => {
  const reg = /^(\d{0,5})(\.(\d{0,2}))?$/g
  const inputValue = e.target.value
  // 如果输入为空，允许继续输入
  if (inputValue === '') {
    formData.value[key][deepKey] = ''
    return
  }
  // 如果输入符合规范，直接使用
  if (reg.test(inputValue)) {
    formData.value[key][deepKey] = inputValue
  } else {
    // 不符合规范时，尝试修正输入
    let correctedValue = inputValue
    // 只保留数字和小数点
    correctedValue = correctedValue.replace(/[^\d.]/g, '')
    // 确保只有一个小数点
    const parts = correctedValue.split('.')
    if (parts.length > 2) {
      correctedValue = parts[0] + '.' + parts.slice(1).join('')
    }
    // 限制整数部分最多5位，小数部分最多2位
    if (parts.length === 2) {
      const integerPart = parts[0].slice(0, 5)
      const decimalPart = parts[1].slice(0, 2)
      correctedValue = integerPart + '.' + decimalPart
    } else if (parts.length === 1) {
      correctedValue = parts[0].slice(0, 5)
    }
    // 如果修正后的值符合规范，使用修正值
    if (reg.test(correctedValue)) {
      formData.value[key][deepKey] = Number(correctedValue)
    } else {
      // 如果修正后仍不符合规范，保持原
      formData.value[key][deepKey] = formData.value[key][deepKey]
    }
  }
}
const handleDecimalBlur = (val1: string, val2: string) => {
  formData.value[val1][val2] = Number(formData.value[val1][val2])
}
const coordinateAxesInput = (e: any, key: string) => {
  const reg = /^[a-zA-Z]$/
  const inputValue = e.target.value
  // 如果输入为空，允许清空
  if (inputValue === '') {
    formData.value.coordinate_axis[key] = ''
    return
  }
  // 如果输入符合规范（单个字母）
  if (reg.test(inputValue)) {
    formData.value.coordinate_axis[key] = inputValue
  } else {
    // 如果输入不符合规范，尝试修正
    // 提取第一个字母（如果有）
    const firstLetterMatch = inputValue.match(/[a-zA-Z]/)
    if (firstLetterMatch) {
      // 如果找到字母，使用第一个字母
      const validValue = firstLetterMatch[0]
      formData.value.coordinate_axis[key] = validValue
    } else {
      formData.value.coordinate_axis[key] = ''
    }
  }
}
// 只能有一把刀选中开料
const onlyOneChecked = (row: any) => {
  if (row.cutable == false) {
    formData.value.back_knives.forEach((v: any) => {
      v.cutable = false
    })
    row.cutable = true
  }
  if (row.cutable == true) {
    formData.value.back_knives.forEach((v: any) => {
      v.cutable = false
    })
    row.cutable = true
  }
}

// 切换刀具类型
const handleChangeKnifeType = (val: string, row: any) => {
  if (val === 'dill') {
    row.axis_offset = ''
    row.arc_radius = ''
    row.slotable = false
    row.millableHole = false
    row.millableSlot = false
    row.knifePurpose = row.knifePurpose.filter((item) => item == 'holeable')
  } else if (val.includes('stylingKnife')) {
    row.axis_offset = ''
    row.arc_radius = ''
    row.holeable = false
    row.slotable = false
    row.millableHole = false
    row.millableSlot = false
    row.knifePurpose = []
  } else if (val.includes('mill')) {
    row.axis_offset = ''
    row.arc_radius = ''
  } else if (val.includes('obliqueDrill')) {
    row.holeable = false
    row.slotable = false
    row.millableHole = false
    row.millableSlot = false
    row.knifePurpose = []
  } else if (val === 'laser') {
    row.holeable = true
    row.slotable = true
    row.millableHole = true
    row.millableSlot = true
    row.knifePurpose = ['holeable', 'slotable', 'millableHole', 'millableSlot']
    if (row.cutable) {
      row.cutable = false
      message.warning(
        that.$translateLang(
          '激光刀不可加工内部未切透的异形，已自动取消"开料"项勾选'
        )
      )
    }
  }
}
// 修改表格中的值
const inputBlur = (row: any, prop: string) => {
  row['desc'] = row['name']
  rowIndex.value = -1
  columnIndex.value = -1
  // 失去焦点判断刀直径是否为0
  if (row['diameter'] === 0) {
    row['diameter'] = ''
  }
  if (row['diameter']) {
    row['diameter'] = Number(row['diameter'])
  }
}
const handleInputCheck = (row, prop, flag) => {
  // 刀具名称不能输入特殊字符
  if (prop == 'name') {
    const regex = /[^a-zA-Z0-9_-]/
    if (regex.test(row[prop])) {
      row[prop] = row[prop].replace(regex, '').trim()
    }
  }
  row['desc'] = row['name']
  if (flag) {
    row[prop] = regReplaceCuttingDockInputCheck(row[prop])
  }
  // 刀径只能输入数字且不能为负数和0
  if (prop === 'diameter') {
    row[prop] = regReplaceCuttingParamsDiameter(row[prop])
  }
  // 轴偏移仅可输入数字、小数点、负号，保留3位整数2位小数
  if (prop === 'axis_offset') {
    row[prop] = regReplaceAxisOffset(row[prop])
  }
  // 圆弧半径仅可输入数字、小数点,保留3位整数2位小数
  if (prop === 'arc_radius') {
    row[prop] = regReplaceArcRadius(row[prop])
  }
}

// 暴露 formData 给父组件
expose({
  formData,
})

return { __sfc: true,that, formData, props, emit, handleChangeLaserEnable, knifeTypeOptionsList, coordinateAxes, handleAddNewKnife, handleDeleteKnife, currentRow, rowIndex, columnIndex, editInputRef, tableKey, changeStyle, columnStyle, headerStyle, headerRowStyle, choseKnife, tableRowClassName, tableCellClassName, cellClick, validatePositiveDecimal, handleDecimalBlur, coordinateAxesInput, onlyOneChecked, handleChangeKnifeType, inputBlur, handleInputCheck, translate, backKnifeStoreConfigList }
}

})